import Parse from 'parse';
import { singleEntityLoading } from '../mixins/loading-states';
/**
 * @class CheckoutModule
 */
const CheckoutModule = {
  namespaced: true,
  state: {
    ...singleEntityLoading.state,
    type: null,
    details: {
      deliveryAddress: null,
      deliveryDate: null,
      contactAtLocation: '',
      project: '',
      notes: '',
      lkw: false,
      phone: '',
      adjoiningArea: false,
      referenceId: '',
      documentsRequired: '',
      termsOfDelivery: {
        fca: false,
        cip: false,
        cif: false,
        unloadingEquipment: false,
      },
    },
  },
  mutations: {
    ...singleEntityLoading.mutations,
    setCheckoutType(state, type) {
      state.type = type;
    },
    setCheckoutDetails(state, details) {
      state.details = details;
    },
  },
  actions: {
    ...singleEntityLoading.actions,
  },
  getters: {
    ...singleEntityLoading.getters,
    checkoutType: (state) => state.type,
    checkoutDetails: (state) => state.details,
  },
};

export default CheckoutModule;
